import ReturnUrls from '@engine/features/merchant/merchant_return_urls';
import SupportedFeatures from '@engine/features/merchant/merchant_supported_features';
import Wpf from '@engine/features/merchant/merchant_wpf_editable_fields';
import WpfLocaleText from '@engine/features/merchant/merchant_wpf_locale_texts';
import WpfPaymentLifetime from '@engine/features/merchant/merchant_wpf_payment_lifetime';
import WpfSupportedFeatures from '@engine/features/merchant/merchant_wpf_supported_features';
var Merchant = {
  Wpf: Wpf,
  WpfSupportedFeatures: WpfSupportedFeatures,
  WpfPaymentLifetime: WpfPaymentLifetime,
  WpfLocaleText: WpfLocaleText,
  ReturnUrls: ReturnUrls,
  SupportedFeatures: SupportedFeatures
};
export default Merchant;